// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { z } from 'zod';

export const projectViewModeSchema = z.enum(['table', 'timeline']);

export type ProjectViewMode = z.infer<typeof projectViewModeSchema>;
